<div [formGroup]="form" (contextmenu)="onRightClick($event)">
    <div [ngSwitch]="inputType">
        <div class="control-field boolean-toggle-field" *ngSwitchCase="'boolean'">
            <span class="boolean-toggle-pill">
                <button type="button" mat-icon-button disableRipple
                    [class.boolean-toggle-active]="form.controls[name]?.value === true"
                    (click)="toggleBoolean(true)">
                    <mat-icon svgIcon="done_circle"></mat-icon>
                </button>
                <button type="button" mat-icon-button disableRipple
                    [class.boolean-toggle-active]="form.controls[name]?.value === false"
                    (click)="toggleBoolean(false)">
                    <mat-icon svgIcon="error_circle"></mat-icon>
                </button>
            </span>
        </div>
        <app-column-filter-value class="control-field" *ngSwitchCase="'value-list'"
            [name]="name" [options]="field.options" [emptyOptionLabel]="field.filterEmptyOptionLabel"
            [allowText]="!field.options"
            [formControlName]="name"></app-column-filter-value>
        <mat-form-field class="control-field" *ngSwitchDefault appearance="outline">
            <input fxFlex matInput [type]="inputType" [formControlName]="name">
            <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
        </mat-form-field>
    </div>
</div>